<template>
    <div class="flex flex-center flex-col bgc-fff align-center fc-666">
        <div class="flex">
            <div class="avatar">
                <img v-if="$store.state.userData.is_wechat" width="64" height="64" style="border-radius: 50%;" :src="$store.state.userData.head_img" alt />
                <img v-else src="http://img.taobao2622.top/home_image/tx.png" alt="">
            </div>
            <div class="marginT-20 marginL-10">{{$store.state.phone ? `Hi~ ${userData.phone}` : 'Hi,你还没有登录哦~' }}</div>
        </div>
        <div v-if="!$store.state.phone" class="marginT-10">
            <el-button type="danger" size="medium" @click="$bus.emit('openLogin')">立即登录</el-button>
            <el-button type="danger" size="medium" @click="$bus.emit('openReg')">免费注册</el-button>
        </div>
        <div v-else>
            <div class="my-money marginT-10 flex align-center">
                <span>可用点券：<span class="fc-theme">{{userData.surplus_total_point}}</span> 点</span>
            </div>
            <div class="marginT-10 text-center">
                <el-button type="danger" size="mini" @click="$router.push('/personCenter')">个人中心</el-button>
            </div>
        </div>
        <div class="text-left fc-666 notice-list" v-if="info.length > 0">
            <div class="fc-333 fs-16 marginT-20">消息中心</div>
            <ul class="fs-12 marginT-10">
                <li class="item" v-for="(item, index) in info.slice(0, 5)" :key="index"><a :href="item.url" target="_blank">{{item.title}}</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { showtime } from '@/index/plugins/timediff'
export default {
    props: {
        info: {
            type: Array,
            default: []
        },
    },
    computed: {
        ...mapState(['userData'])
    },
    methods: {
        showtime
    },
}
</script>

<style lang="scss" scoped>
.notice-list {
    width: 200px;
    a {
        display: inline-block;
        max-width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:hover {
            color: #ff6464;
        }
    }
}
.recharge {
    margin-left: 10px;
}
</style>